import { PageEditMode } from './page-edit-mode';
import { PageEditModeStatus } from './page-edit-mode-status';
import { AbstractPageComponent } from '../../components/bookviewer/page/abstract-page-component';
import { Page } from '../../models/page';
import { PositionHelper } from '../position-helper';
import { PageService } from '../../services/page.service';
import { WhiteboardDrawing } from '../../models/whiteboard-drawing';
import { BookviewerWhiteboardDrawingsService } from '../../services/bookviewer-whiteboard-drawings.service';

export class WhiteboardEditMode implements PageEditMode {

    type = 'WHITEBOARD_LINKING';
    status: PageEditModeStatus;
    whiteboardDrawing: WhiteboardDrawing;
    private pageComponent: AbstractPageComponent;
    private parentDiv: any;

    constructor(private whiteboard: WhiteboardDrawing,
                private whiteboardService: BookviewerWhiteboardDrawingsService,
                private pageService: PageService) {
        this.whiteboardDrawing = whiteboard;
        this.status = PageEditModeStatus['INIT'];
    }

    getPage(): Page {
        if (!this.pageComponent) {
            return undefined;
        }

        return this.pageComponent.page;
    }

    getResult(): any {
        return;
    }

    getStatus(): PageEditModeStatus {
        return this.status;
    }

    onMouseDown($event): void {
        this.status = PageEditModeStatus['STARTED'];

        if (this.pageService.getRealPageNumber(this.getPage().index) < 0) {
            // eslint-disable-next-line max-len
            alert('Auf Titel- und Intro-Seiten können leider keine Whiteboards platziert werden. Bitte platzieren das Whiteboard auf einer nummerierten Buchseite.');

            return;
        }

        this.whiteboard.page_id = this.getPage().id;
        const parentContainer = this.parentDiv;

        const position = PositionHelper.transformPositionFromPixelToPercent(
            PositionHelper.calculateRelativePositionInPixel($event, parentContainer),
            parentContainer
        );

        this.whiteboard.position = position;
        // Bug in backend, returns alwasys position 50, 50
        // (this.whiteboard as any).x_pos = this.whiteboard.position.x;
        // (this.whiteboard as any).y_pos = this.whiteboard.position.y;

        this.whiteboardService.updateWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe();
    }

    onMouseLeave($event): void {
        return;
    }

    onMouseMove($event): void {
        return;
    }

    onMouseUp($event): void {
        this.status = PageEditModeStatus['FINISHED'];

        return;
    }

    onPinch($event): void {
        return;
    }

    setPage(page: AbstractPageComponent): void {
        this.pageComponent = page;
        this.parentDiv = this.pageComponent.getContainer();
    }
}
